const Login = () => import('@/views/LoginView.vue')

export default {
  path: '/logowanie',
  name: 'Login',
  component: Login
}
